import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BroadcastService } from '../../../../../shared/services/broadcast.service';
import { FormService } from '../../../../../shared/services/form.service';
import { takeUntil } from 'rxjs/operators';
import { Subject, forkJoin } from 'rxjs';
import { RxFormGroup } from '@rxweb/reactive-form-validators';
import { MediasService } from '../../../../../services/medias.service';
import { EventType } from '../../../../../shared/interfaces/event.model';
import { CategoryService } from '../../../../../services/category.service';
import { CustomersService } from '../../../../../services/customers.service';
import { SwalService } from '../../../../../shared/services/swal.service';
import { MediaClientsService } from '../../../../../services/media-clients.service';
import { MediaClientModel } from '../models/media-client.model';

@Component({
  selector: 'app-edit-create-media-clients',
  templateUrl: './edit-create-media-clients.component.html',
  styleUrls: ['./edit-create-media-clients.component.scss']
})
export class EditCreateMediaClientsComponent implements OnInit {
  @Input() data: any = {};
	formGroup: RxFormGroup;
	isEdit = false;

  fields: any = {
		name: {
			type: 'input',
			options: {
				path: 'name',
				class: 'col-sm-12',
				label: {
					text: 'Titulo',
					class: 'col-sm-12'
				}
			}
		},
		legal_name: {
			type: 'input',
			options: {
				path: 'legal_name',
				class: 'col-sm-12',
				label: {
					text: 'Razon Social',
					class: 'col-sm-12'
				}
			}
		},
		address: {
			type: 'input',
			options: {
				path: 'address',
				label: {
					text: 'Dirección',
				}
			}
		},
		client_id: {
			type: 'select',
			options: {
				path: 'client_id',
				label: {
					text: 'Partner'
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		},
		company_client_id: {
			type: 'select',
			options: {
				path: 'company_client_id',
				label: {
					text: 'Compañia',
				},
				dropdown: {
					text: 'Seleccione...',
					options: []
				}
			}
		},
		email: {
			type: 'email',
			options: {
				path: 'email',
				label: {
					text: 'Publicidad'
				}
			}
		},
		tax_id: {
			type: 'input',
			options: {
				path: 'tax_id',
				label: {
					text: 'RFC',
				}
			}
		},
		contact_name: {
			type: 'input',
			options: {
				path: 'contact_name',
				label: {
					text: 'Nombre del Representante',
				},
			}
		},
		phone_number: {
			type: 'input',
			options: {
				path: 'phone_number',
				label: {
					text: 'Nombre de Telefono',
				},
			}
		},
		notes: {
			type: 'textarea',
			options: {
				path: 'notes',
				class: 'col-sm-12',
				label: {
					text: 'Nota',
				},
			}
		}

	};

  constructor(private cdr: ChangeDetectorRef,
		public modalRef: BsModalRef,
		private broadcast: BroadcastService,
		private formService: FormService,
		private mediaService: MediasService,
		private categoryService: CategoryService,
		private customersService: CustomersService,
		private sweetService: SwalService,
    private mediaclientService: MediaClientsService,) { this.formService._formEvents
			.pipe(takeUntil(this.atComponentDestroy))
			.subscribe(form => {
				this.formGroup = form;
				this.cdr.detectChanges();
			});}

    isAdmin: boolean = false;

	private atComponentDestroy = new Subject();

  async ngOnInit(): Promise<void> {
    console.log(this.data)
    this.formService.transformIntoFormGroup(MediaClientModel, this.data ?? {});
    
    this.isAdmin = this.data?.IsAdmin || false;
    
		let clientsResponse = await this.customersService.getActives();
    let clients = clientsResponse ?? [];
    clients = clients.map(data => ({ id: data.id, name: data.name }));

    this.fields.client_id.options.dropdown.options = [...clients];

    if (this.data?.item.id) {
			this.isEdit = true;
			this.data.name = this.data.title;
			this.formGroup.get('name')?.setValue(this.data.item.name);
			this.formGroup.get('address')?.setValue(this.data.item.address);
		}
    
  }

}
